import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import AppSection from './components/AppSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import MediaSection from './components/MediaSection';
import FaqSection from './components/FaqSection';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        <HeroSection />
        <RankingSection />
        <FeaturesSection />
        <AppSection />
        <UpdatesSection />
        <TopicsSection />
        <ContactSection />
        <AboutSection />
        <IndexSection />
        <CarouselSection />
        <MediaSection />
        <FaqSection />
        <CommentsSection />
        <CardsSection />
      </main>

      <Footer />
    </div>
  );
}